export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-teal-600 to-teal-700 text-white py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          <div>
            <h3 className="text-xl font-bold mb-4">Excl Projects SL</h3>
            <p className="text-teal-100 text-sm leading-relaxed">
              Your trusted partner in <strong>real estate services</strong>, <strong>property management</strong>, and business consultancy in <strong>Granada and Costa del Sol, Spain</strong>.
            </p>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4 text-lg">Contact</h4>
            <address className="space-y-3 text-sm not-italic">
              <p className="text-teal-100">
                <i className="ri-phone-line mr-2" aria-hidden="true"></i>
                <a href="tel:+34674009683" className="hover:text-white transition-colors">+34 674 009 683</a>
              </p>
              <p className="text-teal-100">
                <i className="ri-mail-line mr-2" aria-hidden="true"></i>
                <a href="mailto:exclprojectssl@gmail.com" className="hover:text-white transition-colors">exclprojectssl@gmail.com</a>
              </p>
            </address>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4 text-lg">Services</h4>
            <nav>
              <ul className="space-y-2 text-sm text-teal-100">
                <li><a href="#services" onClick={(e) => { e.preventDefault(); scrollToSection('services'); }} className="hover:text-white transition-colors">Real Estate Activities</a></li>
                <li><a href="#services" onClick={(e) => { e.preventDefault(); scrollToSection('services'); }} className="hover:text-white transition-colors">Property Management</a></li>
                <li><a href="#services" onClick={(e) => { e.preventDefault(); scrollToSection('services'); }} className="hover:text-white transition-colors">Computer Consultancy</a></li>
                <li><a href="#services" onClick={(e) => { e.preventDefault(); scrollToSection('services'); }} className="hover:text-white transition-colors">Business Management</a></li>
                <li><a href="#services" onClick={(e) => { e.preventDefault(); scrollToSection('services'); }} className="hover:text-white transition-colors">Graphic Design</a></li>
              </ul>
            </nav>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4 text-lg">Quick Links</h4>
            <nav>
              <ul className="space-y-2 text-sm text-teal-100">
                <li><a href="#about" onClick={(e) => { e.preventDefault(); scrollToSection('about'); }} className="hover:text-white transition-colors">About Us</a></li>
                <li><a href="#process" onClick={(e) => { e.preventDefault(); scrollToSection('process'); }} className="hover:text-white transition-colors">Our Process</a></li>
                <li><a href="#faq" onClick={(e) => { e.preventDefault(); scrollToSection('faq'); }} className="hover:text-white transition-colors">FAQ</a></li>
                <li><a href="#contact" onClick={(e) => { e.preventDefault(); scrollToSection('contact'); }} className="hover:text-white transition-colors">Contact</a></li>
              </ul>
            </nav>
            <p className="text-teal-100 text-sm mt-4">
              <strong>Company Number:</strong> B22910665
            </p>
          </div>
        </div>
        
        <div className="border-t border-teal-500 pt-8">
          <p className="text-center text-teal-100 text-sm">
            © {new Date().getFullYear()} Excl Projects SL. All rights reserved. | <a href="https://readdy.ai/?origin=logo" target="_blank" rel="nofollow noopener noreferrer" className="hover:text-white transition-colors">Website Builder</a>
          </p>
        </div>
      </div>
    </footer>
  );
}
